import Stadistic from './Stadistic';
export default Stadistic;
